import gql from 'graphql-tag'

export default gql`
  mutation createCashflowDatum($input: CreateCashflowDatumInput!) {
    createCashflowDatum(input: $input) {
        cashflowDatum {
          data
          year
          category
          source
          reason
          createdAt
          resourceType
          accountable {
            ... on Administrator {
              name
            }
            ... on User {
              name
            }
          }
        }
    }
}
`
